import React from 'react';
import moneyHelper from '../Helpers/moneyHelper';
import CurrencyService from '../Services/CurrencyService';
import ErrorMessage from './ErrorMessage';


export default class MoneyFormatFromCurrencyIdComponent extends React.Component 
{
    static defaultProps = {
        moneySum: 0,
        currencyId: 0
    };

    constructor (props) 
    {
        super(props);
        this.state = {
            formatted: ""
        };
    }

    populateData ()
    {
        if (this.props.currencyId)
        {

            CurrencyService.GetCurrencyById(this.props.currencyId)
                .then(result =>
                {
                    this.setState({ formatted: moneyHelper.toMoneyFormat(this.props.moneySum, result.Code) });
                })
                .catch(error => ErrorMessage.SetErrorMessage("MFFCIC26"));
        }
    }

    componentDidMount () 
    {

        this.populateData();
    }

    componentDidUpdate (prevProps)
    {
        if (prevProps.currencyId !== this.props.currencyId)
        {
            this.populateData();
        }
    }

    render ()
    {
        return this.state.formatted;
    }
}

